import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";

const initialState = {
  title: "Slapie - Delivery Inteligente",
};

const pageTitleSlice = createSlice({
  name: "pageTitle",
  initialState,
  reducers: {
    setPageTitle: (state, action) => {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const { setPageTitle } = pageTitleSlice.actions;
export default pageTitleSlice.reducer;
